// import React, { useState } from 'react';
// import Layout from '../components/Layout';
// import axios from 'axios';
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import { Dropdown } from 'primereact/dropdown';
// import { DigitizeUnSubApi, KickwinUnSubApi, unSubApi, unSubVisionGamesApi, WondermindUnSubApi } from '../Data/api';

// const Unsub = () => {
//   const services = [
//     { name: 'kiddoCraze', code: 'KC', api: unSubApi },
//     { name: 'VisionGames', code: 'VG', api: unSubVisionGamesApi },
//     {name:'DigitizeAi',code:'DA',api:DigitizeUnSubApi},
//      { name: "WonderMind", code: "WM", api: WondermindUnSubApi },
//   { name: "KickWin", code: "KW", api: KickwinUnSubApi},
//   ];
//   const [selectedService, setSelectedService] = useState('');
//   const [msisdn, setMsisdn] = useState('');
//   const [responseMessage, setResponseMessage] = useState(null);

//   const handleSubmit = async () => {
//     if (!msisdn) {
//       toast.error('Please enter MSISDN.', { position: toast.POSITION.TOP_CENTER });
//       return;
//     }

//     try {
//       const response = await axios.post(selectedService.api, { msisdn });
//       console.log("Response:", response.data);

//       const responseData = response?.data; // Extract the response data

//       if (selectedService.code === 'KC' && responseData?.data?.responseParam) {
//         setResponseMessage(responseData?.data?.responseParam?.description);
//       } else if (selectedService.code === 'VG' && responseData?.data) {
//         setResponseMessage(responseData?.data); // Convert object to string
//       }
//       else if (selectedService.code === 'DA' && responseData?.data) {
//         setResponseMessage(responseData?.data);
//       }
//       else {
//         setResponseMessage("Unexpected response received.");
//       }
//     }

//     catch (error) {
//       console.error("API Error:", error);
//       setResponseMessage("An error occurred. Please try again.");
//     }

//   };

//   return (
//     <Layout>
//       <div className='flex justify-center items-center'>
//         <div className='bg-white shadow-lg rounded-lg p-8'>
//           <h1 className='text-2xl font-semibold text-gray-700 text-center mb-6'>
//             Unsubscribe from Service
//           </h1>
//           <div className='flex flex-col items-center space-y-4'>
//             <input
//               type="number"
//               placeholder='Enter your MSISDN'
//               value={msisdn}
//               onChange={(e) => setMsisdn(e.target.value)}
//               className='border-2 border-blue-400 rounded-md h-12 text-center px-4 w-42 focus:outline-none focus:ring-2 focus:ring-blue-500'
//             />

//             <div className="card flex justify-center border-2 border-gray-200 rounded-lg w-[220px]">
//               <Dropdown
//                 value={selectedService}
//                 onChange={(e) => setSelectedService(e.value)}
//                 options={services}
//                 optionLabel="name"
//                 placeholder="Select Service"
//                 className="w-full md:w-14rem py-2"
//               />
//             </div>

//             <button
//               onClick={handleSubmit}
//               className='bg-red-500 hover:bg-red-600 text-white py-2 px-6 rounded-full shadow-md transition-all'
//             >
//               Submit
//             </button>

//             {/* Show response message below the form */}
//             {responseMessage && (
//               <p className='text-center text-gray-900 font-semibold mt-4'>{responseMessage}</p>
//             )}
//           </div>
//         </div>
//       </div>
//       <ToastContainer />
//     </Layout>
//   );
// };

// export default Unsub;

import React, { useState } from "react";
import Layout from "../components/Layout";
import axios from "axios";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Dropdown } from "primereact/dropdown";

import {
  DigitizeUnSubApi,
  KickwinUnSubApi,
  unSubApi,
  unSubVisionGamesApi,
  WondermindUnSubApi,
} from "../Data/api";

const Unsub = () => {
  const services = [
    { name: "kiddoCraze", code: "KC", api: unSubApi },
    { name: "VisionGames", code: "VG", api: unSubVisionGamesApi },
    { name: "DigitizeAi", code: "DA", api: DigitizeUnSubApi },
    { name: "WonderMind", code: "WM", api: WondermindUnSubApi },
    { name: "KickWin", code: "KW", api: KickwinUnSubApi },
  ];

  const [selectedService, setSelectedService] = useState(null);

  const [msisdn, setMsisdn] = useState("");

  const [responseMessage, setResponseMessage] = useState("");

  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!msisdn) {
      toast.error("Please enter MSISDN");

      return;
    }

    if (!selectedService) {
      toast.error("Please select service");

      return;
    }

    setLoading(true);

    setResponseMessage("");

    try {
      const response = await axios.post(selectedService.api, {
        msisdn,
      });

      console.log("UNSUB RESPONSE:", response.data);

      const responseData = response?.data;

      if (selectedService.code === "KC" && responseData?.data?.responseParam) {
        setResponseMessage(responseData.data.responseParam.description);
      } else if (responseData?.data) {
        setResponseMessage(
          typeof responseData.data === "string"
            ? responseData.data
            : JSON.stringify(responseData.data),
        );
      } else if (responseData?.message) {
        setResponseMessage(responseData.message);
      } else {
        setResponseMessage("Unexpected response received");
      }
    } catch (error) {
      console.log("API ERROR", error);

      setResponseMessage("An error occurred. Please try again.");

      toast.error(error?.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layout>
      <div
        className="
min-h-screen
bg-gray-50
flex
justify-center
items-start
px-4
py-10
"
      >
        <div
          className="
w-full
max-w-lg
bg-white
rounded-2xl
shadow-md
p-6
md:p-8
"
        >
          <h1
            className="
text-2xl
md:text-3xl
font-bold
text-center
text-gray-800
mb-8
"
          >
            Unsubscribe User
          </h1>

          <div
            className="
flex
flex-col
items-center
gap-5
"
          >
            <input
              type="number"
              placeholder="Enter MSISDN"
              value={msisdn}
              onChange={(e) => setMsisdn(e.target.value)}
              className="
w-full
h-12
border
border-gray-300
rounded-xl
text-center
px-4
focus:outline-none
focus:ring-2
focus:ring-red-500
"
            />

            <div
              className="
w-full
"
            >
              <Dropdown
                value={selectedService}
                onChange={(e) => setSelectedService(e.value)}
                options={services}
                optionLabel="name"
                placeholder="Select Service"
                className="
w-full
border
rounded-xl
"
              />
            </div>

            <button
              onClick={handleSubmit}
              disabled={loading}
              className="
w-full
h-12
rounded-xl
bg-red-600
hover:bg-red-700
text-white
font-semibold
transition
disabled:opacity-60
"
            >
              {loading ? "Processing..." : "Submit"}
            </button>

            {responseMessage && (
              <div
                className="
w-full
mt-4
p-3
rounded-xl
bg-gray-100
text-gray-800
text-center
font-semibold
"
              >
                {responseMessage}
              </div>
            )}
          </div>
        </div>
      </div>

      <ToastContainer />
    </Layout>
  );
};

export default Unsub;
